import React from "react";
import { useTranslation } from "react-i18next";
import i18n from "../../../language/i18n";
import { normalizeLang } from "../../../utils/localeDataLoader";
import {
  useIntroduceFoundationalsPageQuery,
  useIntroduceFoundationalsQuery,
} from "hooks";

function IntroduceFoundationalValue({ showTitle = true }) {
  useTranslation();
  const currentLang = normalizeLang(i18n.language);
  const { data: localTitle = "", isLoading: isTitleLoading } =
    useIntroduceFoundationalsPageQuery(currentLang);
  const { data: foundationals = [], isLoading: isFoundationalsLoading } =
    useIntroduceFoundationalsQuery(currentLang);

  if (isTitleLoading || isFoundationalsLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="IntroduceFoundationalValue">
      {showTitle && (
        <p
          style={{
            color: "#4db748",
            fontWeight: "600",
            margin: "10px 0 20px 0",
            fontSize: "2rem",
            textAlign: "center",
          }}
        >
          {localTitle}
        </p>
      )}

      {foundationals.map((item, index) => (
        <React.Fragment key={item.id || index}>
          <article className="IntroduceFoundationalValue-content">
            <div className="IntroduceFoundationalValue-content-media">
              <img
                className="IntroduceFoundationalValue-content-img"
                src={item.image}
                alt={item.name || localTitle || "HSV"}
              />
              <span className="IntroduceFoundationalValue-content-signal" aria-hidden="true" />
            </div>
            <div className="IntroduceFoundationalValue-content-left">
              <div
                className="quill-content"
                dangerouslySetInnerHTML={{ __html: item.description }}
              />
            </div>
          </article>
          {index < foundationals.length - 1 && <span className="IntroduceFoundationalValue-divider" />}
        </React.Fragment>
      ))}
    </div>
  );
}

export default IntroduceFoundationalValue;
